// extracted by mini-css-extract-plugin
export var sngr_header = "styles-module--sngr_header--3JEX1";
export var sngr_header_inner = "styles-module--sngr_header_inner--3YRzD";
export var sngr_header_logo = "styles-module--sngr_header_logo--2lEuD";
export var sngr_header_navbar = "styles-module--sngr_header_navbar--2VAes";
export var sngr_header_mobileNav_toggle = "styles-module--sngr_header_mobileNav_toggle--30LIE";
export var sngr_header_mobileNav = "styles-module--sngr_header_mobileNav--2il96";
export var sngr_header_mobileNav_content = "styles-module--sngr_header_mobileNav_content--n_ltc";
export var fadeIn = "styles-module--fadeIn--2v6Le";